var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Pagination',_vm._g(_vm._b({attrs:{"itemsCount":_vm.quizCount,"greenItems":_vm.correctAnswered,"redItems":_vm.wrongAnswered,"yellowItems":_vm.notAnswered}},'Pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }